import { Controller } from "@hotwired/stimulus"

// Live inline match validation between a password field and its confirmation.
// Wraps two .form-group nodes; reads from both inputs on input event and
// updates a status node ("Passwords match" / "Passwords don't match").
//
// Usage:
//   div data-controller="password-match"
//     input[type=password] data-password-match-target="password"
//                          data-action="input->password-match#check"
//     input[type=password] data-password-match-target="confirmation"
//                          data-action="input->password-match#check"
//     div data-password-match-target="status"
export default class extends Controller {
  static targets = ["password", "confirmation", "status"]

  connect() { this.clearStatus() }

  check() {
    if (!this.hasPasswordTarget || !this.hasConfirmationTarget || !this.hasStatusTarget) return
    const pwd = this.passwordTarget.value
    const confirm = this.confirmationTarget.value

    if (!confirm) { this.clearStatus(); return }

    if (pwd === confirm) {
      this.statusTarget.innerHTML = '<i class="ph-fill ph-check-circle"></i> Passwords match'
      this.statusTarget.className = "password-match-status password-match-status--success"
    } else {
      this.statusTarget.innerHTML = '<i class="ph ph-warning-circle"></i> Passwords don\'t match'
      this.statusTarget.className = "password-match-status password-match-status--error"
    }
  }

  clearStatus() {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = ""
    this.statusTarget.className = "password-match-status"
  }
}
